import BaseRepository from '../../../baseRepository/BaseRepository';
const resource = `/api/v1/persons`;

export default {
  getFilterPerson(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/filter`, {
      baseURL,
      headers,
      params,
    });
  },
};
